<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-green-50 to-emerald-50">
  <div class="max-w-2xl mx-auto px-8 py-12">
    <div class="bg-white rounded-2xl shadow-2xl p-12 text-center border-t-4 border-[#17A34A]">
      <!-- Logo/Icon -->
      <div class="mb-8">
        <div class="inline-flex items-center justify-center w-32 h-32">
          <img src="assets/telly/telly-waving.png" alt="Ask Telly" class="w-full h-full object-contain rounded-2xl" />
        </div>
      </div>

      <!-- Title -->
      <h1 class="text-4xl font-bold text-gray-900 mb-4">
        Ask Telly
      </h1>

      <!-- Subtitle -->
      <p class="text-xl text-gray-600 mb-8">
        Your Intelligent Knowledge Assistant
      </p>

      <!-- Authorization Notice -->
      <div class="bg-green-50 border-l-4 border-[#17A34A] p-6 mb-8">
        <div class="flex items-start">
          <i class="pi pi-exclamation-triangle text-[#17A34A] text-2xl mr-4 flex-shrink-0 mt-1"></i>
          <div class="text-left">
            <h2 class="text-lg font-semibold text-[#0F5E2D] mb-2">Authorized Use Only</h2>
            <p class="text-[#0F5E2D] leading-relaxed">
              This system is for authorized InfoCision personnel and clients only.
              Unauthorized access, use, or disclosure of this system is strictly prohibited
              and may result in disciplinary action and/or civil and criminal penalties.
            </p>
          </div>
        </div>
      </div>

      <!-- Access Information -->
      <div class="text-sm text-gray-500 space-y-2">
        <p>Access to specific knowledge bases is provided via unique URLs.</p>
        <p>If you have been provided with an access link, please use that link to continue.</p>
      </div>

      <!-- Footer -->
      <div class="mt-8 pt-6 border-t border-gray-200">
        <div class="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-4 text-xs text-gray-400 mb-3">
          <div class="flex items-center space-x-2">
            <span class="text-gray-500">Version:</span>
            <span class="font-mono bg-green-50 px-2 py-1 rounded text-[#0F5E2D]">
              {{ versionString }}
            </span>
          </div>
          <span class="hidden sm:inline text-gray-300">|</span>
          <div class="flex items-center space-x-1 text-gray-500">
            <i class="pi pi-calendar" style="font-size: 10px;"></i>
            <span>{{ buildDate }}</span>
          </div>
        </div>
        <!-- InfoCision Logo -->
        <div class="mb-3">
          <img src="assets/telly/infocision-logo.svg" alt="InfoCision" class="h-6 mx-auto opacity-70" />
        </div>
        <p class="text-xs text-gray-400">
          &copy; {{ currentYear }} InfoCision Management Corporation. All rights reserved.
        </p>
      </div>
    </div>
  </div>
</div>
